module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('header', [_c('div', {
    staticClass: "flex"
  }, [_c('h1', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.title) + " "), (_vm.subtitle) ? _c('span', [_vm._v(_vm._s(_vm.subtitle))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "actions"
  }, [(_vm.showStartButton) ? _c('button', {
    staticClass: "start-run-btn",
    class: {
      'animate': _vm.isAnimating, 'auto-mode': _vm.isAutoMode
    },
    on: {
      "click": _vm.handleStartRun
    }
  }, [_vm._v("\n        " + _vm._s(_vm.startButtonText) + "\n        "), _c('span', {
    staticClass: "btn-glow"
  }), _vm._v(" "), (_vm.isAutoMode) ? _c('div', {
    staticClass: "pill-container"
  }, [_c('span', {
    staticClass: "auto-indicator"
  }, [_vm._v("AUTO")]), _vm._v(" "), (_vm.countdownTime) ? _c('span', {
    staticClass: "countdown-pill"
  }, [_vm._v(_vm._s(_vm.formattedCountdown))]) : _vm._e()]) : _vm._e()]) : _vm._e(), _vm._v(" "), _vm._t("actions")], 2)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-f724e15e"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Race/Header.vue
// module id = 1724
// module chunks = 1